// extracted by mini-css-extract-plugin
export var loadingSpinner = "_26-0";
export var spinnerContainer = "_26-1";